import { settingsRow } from "./businessPreset";

export const SAVE_FAILED_MESSAGE = "We couldn't save that. Please try again in a moment.";
export const SAVE_DEMO_MESSAGE = "The sample business can't be changed. Sign up to set your own business type.";

// Saves the owner's business type on their own contractors row (the signed-in user's id; row-level security
// also limits the update to that row). client is the Supabase client, passed in so this can be tested.
// Returns { ok: true, row } with the columns saved, or { ok: false, message } in plain words. It fails the same
// plain way when the columns do not exist yet (the migration has not been applied) or no row was updated.
export async function saveBusinessType({ client, userId, demo, key, paysPeople }) {
  if (demo) return { ok: false, message: SAVE_DEMO_MESSAGE };
  if (!userId) return { ok: false, message: SAVE_FAILED_MESSAGE };
  try {
    const row = settingsRow(key, paysPeople);
    const { data, error } = await client.from("contractors").update(row).eq("id", userId).select("id");
    if (error || !Array.isArray(data) || data.length === 0) return { ok: false, message: SAVE_FAILED_MESSAGE };
    return { ok: true, row };
  } catch (e) {
    return { ok: false, message: SAVE_FAILED_MESSAGE };
  }
}
